import { Button, Space } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import dayjs from 'dayjs';
import React from 'react';

import type { EdutainmentApplication } from '../../types';

export const getTableColumns = () => {
  const columns: ColumnsType<EdutainmentApplication> = [
    {
      title: '育樂名稱',
      dataIndex: 'name',
    },
    {
      title: '所屬計費方案',
      dataIndex: 'plans',
      width: 300,
      render: (plans: string[]) => {
        return plans.join('/');
      },
    },
    {
      title: '育樂類別',
      dataIndex: 'category',
    },
    {
      title: '狀態',
      dataIndex: 'status',
    },
    {
      title: '育樂開始日期(年/月/日)',
      dataIndex: 'startDate',
      render: (startDate: number) => {
        return dayjs(startDate).format('YYYY/MM/DD');
      },
      sorter: (a, b) => a.startDate - b.startDate,
    },
    {
      title: '育樂結束日期(年/月/日)',
      dataIndex: 'endDate',
      render: (endDate: number) => {
        return dayjs(endDate).format('YYYY/MM/DD');
      },
      sorter: (a, b) => a.endDate - b.endDate,
    },
    {
      title: '育樂時間',
      dataIndex: 'times',
      width: 300,
      render: (times: string[]) => {
        return times.join('/');
      },
    },
    {
      title: '育樂主管',
      dataIndex: 'administrator',
    },
    {
      title: '講師',
      dataIndex: 'teacher',
    },
    {
      title: '操作',
      dataIndex: 'action',
      fixed: 'right',
      render: (_, record) => {
        return (
          <Space>
            <Button type="primary" onClick={() => console.log('查看:', record)}>
              查看
            </Button>
            <Button onClick={() => console.log('複製活動:', record)}>
              複製活動
            </Button>
          </Space>
        );
      },
    },
  ];
  return columns;
};
